import React from 'react';
import { Site } from '@/types/models/sites.types';
import { AssetsHealthStates } from '@/types/models/sites.types';

export type SiteChartDataType = Array<{
  healthStatus: AssetsHealthStates;
  value: number;
  color: string;
  fill: string;
}>;

export type SiteDataType = Site & {
  fixed_chart_data: SiteChartDataType;
  mobile_chart_data: SiteChartDataType;
};

const getChartData = (assetsHealthStatusesCounts: Record<AssetsHealthStates, number>): SiteChartDataType => {
  return [
    {
      healthStatus: 'critical',
      value: assetsHealthStatusesCounts.critical,
      color: 'bg-critical',
      fill: 'hsl(var(--bg-critical))',
    },
    {
      healthStatus: 'alarm',
      value: assetsHealthStatusesCounts.alarm,
      color: 'bg-alarm',
      fill: 'hsl(var(--bg-alarm))',
    },
    {
      healthStatus: 'monitor',
      value: assetsHealthStatusesCounts.monitor,
      color: 'bg-monitor',
      fill: 'hsl(var(--bg-monitor))',
    },
    {
      healthStatus: 'healthy',
      value: assetsHealthStatusesCounts.healthy,
      color: 'bg-healthy',
      fill: 'hsl(var(--bg-healthy))',
    },
    {
      healthStatus: 'na',
      value: assetsHealthStatusesCounts.na,
      color: 'bg-notMonitored',
      fill: 'hsl(var(--bg-not-monitored))',
    },
  ];
};

export const useSitesData = (sites: Site[] | undefined) => {
  const data: SiteDataType[] = sites
    ? sites.map((site) => {
        return {
          ...site,
          fixed_chart_data: getChartData(site.assets_categories.fixed.assets_health_statuses_counts),
          mobile_chart_data: getChartData(site.assets_categories.mobile.assets_health_statuses_counts),
        };
      })
    : [];

  return {
    data,
  };
};
